// A tiny external store around the pure reducer, read from React with useSyncExternalStore.
import { useSyncExternalStore } from "react";
import { initialState, reduce, type Action, type AppState } from "./model";

export type Store = {
  getState: () => AppState;
  dispatch: (action: Action) => void;
  subscribe: (fn: (state: AppState) => void) => () => void;
};

export function createStore(start: AppState = initialState): Store {
  let state = start;
  const listeners = new Set<(s: AppState) => void>();
  return {
    getState: () => state,
    dispatch(action) {
      const next = reduce(state, action);
      if (next === state) return;
      state = next;
      for (const fn of listeners) fn(state);
    },
    subscribe(fn) {
      listeners.add(fn);
      return () => listeners.delete(fn);
    },
  };
}

export function useStoreState<T>(store: Store, select: (s: AppState) => T): T {
  return useSyncExternalStore(store.subscribe, () => select(store.getState()), () => select(store.getState()));
}
